import { Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';

import { RoutesByType, RoutesFacade, RouteEntity, RouteType } from '@ridango/components';
import { keyCode, ListService } from '@ridango/core';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-route-list',
    templateUrl: './route-list.component.html',
    styleUrls: ['./route-list.component.scss'],
})
export class RouteListComponent implements OnInit, OnDestroy {
    @Input() types: RouteType[];

    private componentDestroyed$ = new Subject();
    private selectedIndex = 0;

    allRoutes: RouteEntity = {};
    routeIdsByType: RoutesByType;

    loading$: Observable<boolean> = this.routesFacade.loading$;

    @ViewChildren('listItem') listItems: QueryList<ElementRef>;

    constructor(private routesFacade: RoutesFacade, private listService: ListService) {}

    ngOnInit() {
        this.routesFacade.allRoutes$.pipe(takeUntil(this.componentDestroyed$)).subscribe((all) => {
            this.allRoutes = all;
        });

        this.routesFacade.routeListDates$.pipe(takeUntil(this.componentDestroyed$)).subscribe((dates) => {
            if (dates.length > 0) {
                this.routesFacade.getRoutesByType(dates).pipe(takeUntil(this.componentDestroyed$)).subscribe(
                    (r) => this.routeIdsByType = r
                );
            }
        });
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    setFocusOnNextItem(event: KeyboardEvent, listSize: number) {
        switch (event.keyCode) {
            case keyCode.ARROW_DOWN:
                event.preventDefault();
                this.selectNextItem(1, listSize);
                break;
            case keyCode.ARROW_UP:
                event.preventDefault();
                this.selectNextItem(-1, listSize);
                break;
        }
    }

    private selectNextItem(direction: number, listSize): void {
        this.selectedIndex = this.listService.getNextCyclicIndex(this.selectedIndex, direction, listSize);
        setTimeout(() => this.listItems.toArray()[this.selectedIndex].nativeElement.focus());
    }
}
